import React, { useRef } from "react";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import axios from "axios";
import LogsService from "../../utils/logs";
import getEnvEndpoints from "../../utils/endpoints";
import { getContentDetailsOnClick } from '../../../src/utils/utility'

const endpoints = getEnvEndpoints();

const DownloadModal = ({ post, downloads, onClose, onDownloaded }) => {
  const ref = useRef(null);

  const closeModal = () => {
    document.querySelector("body").classList.remove("overflow-hidden");
    onClose();
  };

  useOnClickOutside(ref, () => {
    closeModal();
  });

  const download = file => {
    const url = file.filePath
      ? file.filePath
      : endpoints.baseContentUrl + file.relativePath;

    axios.get(url, { responseType: "blob" }).then(async ({ data }) => {
      let blob = new Blob([data]);
      if (navigator.msSaveOrOpenBlob) {
        // IE 11
        navigator.msSaveOrOpenBlob(blob, file.title + "." + file.fileFormat);
      } else {
        // Modern Browsers
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = file.title + "." + file.fileFormat;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      onDownloaded();
      await LogsService.logDownloadClick({
        contentKey: post.contentKey,
        contentSubKey: url.split("/").pop()
      });
    });
  };

  const downloadTrack = (file) => {
    getContentDetailsOnClick(post, "download", "card-footer")
  }
  return (
    <div
      className="fixed pin z-50 overflow-auto flex items-center"
      style={{
        backgroundColor: "rgba(0, 0, 0, .4)",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0
      }}
    >
      <div
        ref={ref}
        className="relative p-8 border-2 border-gray-800 bg-white w-full max-w-md m-auto h-custom"
        style={{
          height: "300px",
          width: "480px"
        }}
      >
        <div className="text-right">
          <button onClick={closeModal} className="w-3 cursor-pointer p-4">
            X
          </button>
        </div>

        <h3 className="text-center mt-2 mb-4 text-xl font-bold">
          Downloadable Files
        </h3>

        {downloads.map((file, i) => (
          <div className="my-2" key={i}>
            <div className="flex flex-wrap justify-center my-5">
              <span
                onClick={() => {
                  downloadTrack(file)
                  download(file)
                }}
                className="font-bold break-words mr-4 cursor-pointer hover:text-blue-700"
              >
                {file.title}
              </span>
              <i
                onClick={() => {
                  downloadTrack(file)
                  download(file)
                }}
                className="fas fa-download hover:text-blue-700 cursor-pointer"
              ></i>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DownloadModal;
